{
  "checkoutProductUsps": "Abonnementsvoordelen",
  "yourChoice": "Jouw keuze",
  "yourCurrentSubscription": "Jouw huidige abonnement",
  "qty": "Aantal",
  "issues": "nummers",
  "total": "Totaal {0}",
  "startingDateLabel": "Ingangsdatum",
  "discountPeriod": "Kortingsperiode",
  "priceAfterDiscount": "Na kortingsperiode",
  "period": "Looptijd",
  "contractDuration": "Looptijd",
  "asap": "Zo snel mogelijk",
  "direct": "Direct",
  "discount_amount": "{0}% korting",
  "gift": "Geef cadeau",
  "priceCartLabel": {
    "free": "gratis",
    "month": "per maand",
    "year": "per jaar",
    "week": "per week",
    "issue": "per nummer",
    "magazine": "per nummer",
    "quarter": "per kwartaal",
    "one-time": "eenmalig",
    "semi-annual": "per half jaar",
    "annual": "per jaar"
  },
  "pricingLabel": {
    "month": "maand",
    "months": "maanden",
    "week": "week",
    "weeks": "weken"
  },
  "durationSubtitle": "Kies een langere kortingsperiode voor extra hoge korting",
  "trialCancelationText": "Stopt vanzelf",
  "trialSubscriptionTitle": "{0} proefabonnement",
  "components": {
    "appPropositionSelector": {
      "trialSubscriptionFooterText": "Stopt vanzelf"
    },
    "baseAccountMenu": {
      "login": "Inloggen"
    },
    "baseCheckoutSummaryMobilePreview": {
      "viewDetails": "Bekijk details"
    },
    "baseCustomerServiceWidget": {
      "customerServiceLink": "Abonnement beheren"
    },
    "baseNewsletter": {
      "subscribe": "Inschrijven",
      "subscribeSuccess": "Het aanmelden is gelukt.",
      "subscribeError": "Er is iets mis gegaan."
    },
    "basePromotionCode": {
      "promotionCode": "Vul je actiecode in",
      "promotionCodePlaceholder": "Actiecode",
      "apply": "Haal je aanbod op",
      "isValidatingButtonText": "Actiecode controleren..."
    },
    "baseUspModalContent": {
      "cta": "Kies je abonnement"
    }
  },
  "businessHourContent": {
    "closed": "Vragen, wijzigen of opzeggen?",
    "open": "Telefonisch bestellen? Bel:"
  },
  "baseCheckoutWrapper": {
    "ctaFree": "Bestel gratis",
    "ctaOrder": "Bestellen en betalen",
    "ctaOrderFree": "Gratis bestellen"
  },
  "checkoutForm": {
    "title": "Vul je gegevens in"
  },
  "error": {
    "checkout": {
      "subscriber_exists_link": "Log in op Mijn Omgeving",
      "subscriber_exists": "Er bestaat al een {0}-abonnement met deze gegevens. Log in op Mijn Omgeving om je huidige abonnement te beheren."
    }
  },
  "upsellSelector": {
    "lib": {
      "LIBDP": "Bezorg mij ook elke week Libelle weekblad",
      "LIBEL": "Bezorg mij ook Libelle Specials (16x per jaar)"
    },
    "mar": {
      "MARDP": "Bezorg mij ook elke week Margriet weekblad",
      "MARGR": "Bezorg mij ook Margriet Extra (9x per jaar)",
      "MARPL": "Bezorg mij ook elke 2 maanden Margriet Puzzelen"
    },
    "flr": {
      "FLRDP": "Bezorg mij ook elke week Flair weekblad"
    },
    "vtw": {
      "VTWON": "Bezorg mij ook vtwonen specials (4x per jaar)"
    },
    "hu": {
      "digitaal": "Bezorg mij ook elke week Humo op papier"
    },
    "digitaalbasis": "Ontvang ook dagelijks de digitale krant met bijlagen (pdf) voor maar {extraPrice} extra",
    "digitaal": "Bezorg mij ook de zaterdagkrant voor maar {extraPrice} extra",
    "zaterdagplus": "Bezorg mij ook maandag t/m vrijdag de papieren krant voor maar {extraPrice} extra",
    "variation_1": {
      "digitaalbasis": "Lees ook de digitale krant voor maar {extraPrice} per week",
      "digitaal": "Bezorg mij ook elke zaterdag de extra dikke weekendkrant met alle bijlagen voor maar {extraPrice} per week",
      "zaterdagplus": "Bezorg mij ook maandag t/m vrijdag de papieren krant voor maar {extraPrice} per week"
    }
  },
  "formulaSelector": {
    "title": "Hoe wil je {title} lezen?"
  },
  "durationSelector": {
    "title": "Kies je {0}",
    "periodLabel": "kortingsperiode",
    "titleWithoutDiscounts": "Kies je looptijd",
    "tempDurationTitle": "Je kortingsperiode",
    "singleDurationTitle": "Jouw kortingsperiode",
    "durationSubtitle": "Kies een langere kortingsperiode voor extra hoge korting",
    "trialPriceSuffix": "Stopt vanzelf",
    "showMoreDurations": "Kortere kortingsperiode",
    "duration": {
      "free": "Gratis",
      "footerText": "{0} korting",
      "footerTextVariation": "{0} korting, je bespaart {1} per jaar",
      "temporaryPromoBadge": "Tijdelijke actie",
      "highestDiscount": "Hoogste korting",
      "mostChosen": "Meest gekozen"
    },
    "disclaimer": {
      "variation": "De korting is geldig voor {0} maanden, ook tijdens deze periode kan je maandelijks opzeggen.",
      "default": "Na deze periode kan je maandelijks opzeggen.",
      "afterDuration": "Na {0} {1} kan je maandelijks opzeggen.",
      "cancel": "Je kunt je bestelling binnen 14 dagen annuleren.",
      "tempPromotion": "Dit abonnement is altijd opzegbaar.",
      "trialSubscription": "Na {0} {1} stopt jouw proefabonnement vanzelf.",
      "freeSubscription": "Na {0} {1} stopt jouw gratis abonnement vanzelf.",
      "csrSubscription": "Het abonnement stopt automatisch na {0} {1}.",
      "tempVersimpelenTestPromotion": "Het abonnement is altijd opzegbaar. Je kunt je bestelling binnen 14 dagen annuleren.",
      "fluisterFreeMonth": "Je ontvangt in de eerste twee maanden één maand gratis. Daarom krijg je in deze 2 maanden iedere maand 50% korting op je factuur (je leest en luistert dan voor €{1} per week). Vanaf maand 3 lees je voor €{2} per week en kun je maandelijks opzeggen.",
      "freeMonth4Pv": "Je ontvangt in de eerste twee maanden één maand gratis. Daarom ontvang je de eerste twee maanden 50% korting op je factuur. Vanaf maand 3 lees je voor €{0} per week en kun je maandelijks opzeggen."
    }
  },
  "propositionProductFormulaLabels": {
    "compleet": "Compleet",
    "digitaal": "Digitaal",
    "digitaalbasis": "Digitaal Basis",
    "zaterdagplus": "Zaterdag + Digitaal"
  },
  "studentVerification": {
    "title": "Verificatie studentenstatus",
    "title_not_logged_in": "Log in of maak een account",
    "title_already_subscribed": "Je hebt al een gratis studentenabonnement",
    "title_invalid_age_group": "Je valt buiten de leeftijdscategorie",
    "not_logged_in": {
      "title": "Om gebruik te kunnen maken van dit aanbod, log je in met je DPG-account.",
      "subtitle": "Als je nog geen DPG-account hebt, dan kun je er in het volgende scherm eenvoudig een aanmaken. Vervolgens checken we of je student bent.",
      "callToAction": {
        "primary": "Ga verder"
      }
    },
    "invalid_age_group": {
      "title": "Je valt buiten de leeftijdscategorie van 16 tot 25 jaar en komt daarom niet in aanmerking voor.",
      "subtitle": "Er staat wél een andere mooie korting voor je klaar.",
      "callToAction": {
        "primary": "Bekijk andere aanbiedingen"
      }
    },
    "already_subscribed": {
      "title": "Je hebt al een gratis studentenabonnement en dus onbeperkt toegang tot de apps van 11 kranten.",
      "subtitle": "Om te lezen, log je in met je DPG Media-account in de apps van onderstaande kranten:"
    },
    "verified": {
      "title": "Het is gelukt!",
      "subtitle": "Ga verder en controleer je gegevens."
    },
    "error": {
      "title": "Helaas",
      "subtitle": "het is niet gelukt om je als student te verifieren.",
      "callToAction": {
        "primary": "Alle abonnementen",
        "secondary": "Probeer opnieuw"
      }
    },
    "not_started": {
      "subtitle": "Om gebruik te kunnen maken van dit aanbod, checken we even of je echt student bent.",
      "callToAction": {
        "primary": "Verifieer je als student"
      }
    }
  },
  "checkoutUsps": {
    "cancelation": {
      "always": "Altijd opzegbaar",
      "easy": "Gemakkelijk opzegbaar"
    },
    "delivery": "Zo snel mogelijk thuis geleverd",
    "digital": "Start direct met digitaal lezen",
    "trial": "14 dagen bedenktijd",
    "introductoryDiscountForNewSubscribers": "Kennismakingskorting voor nieuwe abonnees"
  },
  "orderNote": "Je ontvangt binnen 24 uur een bevestigingsmail.<br/>Je kunt je bestelling binnen 14 dagen annuleren.",
  "orderNoteCsr": "Je ontvangt binnen 24 uur een bevestigingsmail.",
  "basePvExplanation": {
    "title": "Hoelang krijg ik korting?",
    "description": "Uitleg over de kortingsperiode",
    "intro": "Je krijgt in totaal maar liefst {duration} korting op het reguliere tarief:",
    "firstPeriod": "Bij deze actie geldt de eerste {period} een kennismakingstarief van {price}",
    "middlePeriod": "Vervolgens geldt {period} een kortingstarief van {price}",
    "lastPeriod": "Daarna geldt {period} een kortingstarief van {price}.",
    "regularRate": "Na {duration} gaat het reguliere tarief in.",
    "cancellation": "Het abonnement is {info} opzegbaar"
  },
  "promoPeriods": {
    "first": "Eerste {period}",
    "after": "na {period}",
    "later": "+ {period} hoge kortingen",
    "price": "{price} /{unit}"
  },
  "alwaysCancelable": "Altijd opzegbaar",
  "alwaysCancelableModal": {
    "description": "Je kunt op ieder moment gemakkelijk opzeggen. Je bent dus niet verplicht een kortingsperiode af te maken. Opzeggen kan via onze <a href=\"{cancelLink}\">online-selfservice</a>. Ook kun je met korting een andere leesvorm proberen. Ontdek de mogelijkheden <a href=\"{link}\">hier</a>."
  },
  "modificationSelector": {
    "button": {
      "open": "Wijzig",
      "close": "Sluit"
    }
  },
  "productOverview": {
    "title": "Kies jouw nieuwe tijdschrift",
    "filterCategory": "Filter op categorie",
    "filterType": "Filter op type",
    "noResults": "Sorry! We kunnen niet vinden wat je zoekt.",
    "results": "We waren op zoek naar",
    "search": "Zoeken",
    "clear": "Reset"
  },
  "links": {
    "productCardCta": "Bekijk aanbod",
    "discoverAll": "Ontdek alles"
  },
  "thema": {
    "proefabonnementen": {
      "title": "Proefabonnementen",
      "subtitle": "Drie nummers op te proberen"
    }
  },
  "endlessFaq": {
    "label": "Stel je eigen vraag",
    "placeholder": "Stel je eigen vraag",
    "submit": "Vraag stellen",
    "loading": "Even kijken...",
    "error": "Er is iets misgegaan. Probeer het opnieuw.",
    "rateLimited": "Je hebt veel vragen gesteld. Probeer het over een minuut opnieuw.",
    "disclaimer": "Antwoorden worden gegenereerd door AI en kunnen fouten bevatten. Neem bij twijfel contact op met onze {customerService}.",
    "customerService": "klantenservice"
  }
}
